// @ts-nocheck
/* Combined Call Centres List options modal — Voicemail + Transcription share
 * one edit_options array, so they're granted from a single modal/button. */
import React, { useEffect, useState } from 'react';
import {
  VOICEMAIL_ACL_OPTION,
  normalizeCallCentreEditOptions,
} from '@/utilities/callCentreVoicemailAcl';
import {
  TRANSCRIPTION_ACL_OPTION,
  normalizeCallCentreTranscriptionOptions,
} from '@/utilities/callCentreTranscriptionAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaVoicemail,
  FaMicrophone,
} from '@/features/acl-settings/aclSettingsUi';

const CallCentreVoicemailAclModal = ({
  show,
  onHide,
  initialOptions,
  optionsConfigured = false,
  onSave,
  limitedByParent = false,
  canGrantVoicemail = true,
  canGrantTranscription = true,
}) => {
  const [voicemailEnabled, setVoicemailEnabled] = useState(false);
  const [transcriptionEnabled, setTranscriptionEnabled] = useState(false);

  useEffect(() => {
    if (show) {
      const options = Array.isArray(initialOptions) ? initialOptions : [];
      if (!optionsConfigured) {
        setVoicemailEnabled(false);
        setTranscriptionEnabled(false);
      } else {
        setVoicemailEnabled(normalizeCallCentreEditOptions(options).includes(VOICEMAIL_ACL_OPTION));
        setTranscriptionEnabled(
          normalizeCallCentreTranscriptionOptions(options).includes(TRANSCRIPTION_ACL_OPTION),
        );
      }
    }
  }, [show, initialOptions, optionsConfigured, canGrantVoicemail, canGrantTranscription]);

  const handleReset = () => {
    setVoicemailEnabled(false);
    setTranscriptionEnabled(false);
  };

  const handleSave = () => {
    const others = (Array.isArray(initialOptions) ? initialOptions : []).filter(
      (o) => o !== VOICEMAIL_ACL_OPTION && o !== TRANSCRIPTION_ACL_OPTION && o !== 'leads',
    );
    const next = [
      ...others,
      ...(voicemailEnabled ? [VOICEMAIL_ACL_OPTION] : []),
      ...(transcriptionEnabled ? [TRANSCRIPTION_ACL_OPTION] : []),
    ];
    onSave({ edit_options: [...new Set(next)] });
    onHide();
  };

  const canGrantAnything = canGrantVoicemail || canGrantTranscription;

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Call Centers — Options"
      icon={FaVoicemail}
      description="Grant permission to enable voicemail and live-call transcription on call centers."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canGrantAnything}
    >
      <AclModalSection
        icon={FaVoicemail}
        title="Voicemail Permission"
        subtitle="Allow enabling voicemail at call center, call group, and agent level."
      >
        {!canGrantVoicemail ? (
          <p className="acl-modal-empty">
            You do not have permission to grant voicemail on call centers.
          </p>
        ) : (
          <AclModalOptionCheck
            id="cc-acl-voicemail"
            label="Voicemail"
            description="Allow enabling voicemail at call center, call group, and agent level"
            checked={voicemailEnabled}
            onChange={(e) => setVoicemailEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>

      <AclModalSection
        icon={FaMicrophone}
        title="Transcription Permission"
        subtitle="Allow enabling live-call transcription at call center and agent level."
      >
        {!canGrantTranscription ? (
          <p className="acl-modal-empty">
            You do not have permission to grant transcription on call centers.
          </p>
        ) : (
          <AclModalOptionCheck
            id="cc-acl-transcription"
            label="Transcription"
            description="Allow enabling live-call transcription at call center and agent level"
            checked={transcriptionEnabled}
            onChange={(e) => setTranscriptionEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default CallCentreVoicemailAclModal;
